/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../../../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../../../../../magnolia/lib/MagnoliaPropertyHelper';

export interface slidesStruct {
  ctaText ? : string;
  pageLink ? : any;
  intLinkParam ? : string;
  pdfLinkInDam ? : Asset;
  showCtaAsPdf ? : boolean;
  linkTargetMode ? : string;
}
export default interface OneCTText {
  legalTitle ? : string;
  legalText ? : string;
  enableLegalDisclaimer ? : boolean;
  titleOrSubtitle ? : string;
  topTitle ? : string;
  topTitleColor ? : number;
  title ? : string;
  titleColor ? : number;
  subText ? : string;
  subTextColor ? : number;
  backgroundColor ? : string;
  slides ? : Array < slidesStruct > ;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  legalTitle: String,
  legalText: String,
  enableLegalDisclaimer: Boolean,
  titleOrSubtitle: String,
  topTitle: String,
  topTitleColor: Number,
  title: String,
  titleColor: Number,
  subText: String,
  subTextColor: Number,
  backgroundColor: String,
  slides: Array as() => Array < slidesStruct > ,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  legalTitle: String,
  legalText: String,
  enableLegalDisclaimer: Boolean,
  titleOrSubtitle: String,
  topTitle: String,
  topTitleColor: Number,
  title: String,
  titleColor: Number,
  subText: String,
  subTextColor: Number,
  backgroundColor: String,
  slides: Object,
  dataABId: String,
  metadata: Object,
}

export class OneCTTextBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class OneCTTextInstance implements OneCTText {
      legalTitle ? : string;
      legalText ? : string;
      enableLegalDisclaimer ? : boolean;
      titleOrSubtitle ? : string;
      topTitle ? : string;
      topTitleColor ? : number;
      title ? : string;
      titleColor ? : number;
      subText ? : string;
      subTextColor ? : number;
      backgroundColor ? : string;
      slides ? : Array < slidesStruct > ;
      dataABId ? : string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.slides) {
          this.slides = Object.entries(this.slides)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'slides' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.slides.length; i1++) {
            if (this.slides[i1]) {
              if (typeof this.slides[i1].pdfLinkInDam === 'object') {
                this.slides[i1].pdfLinkInDam = {
                  ...this.slides[i1].pdfLinkInDam,
                  link: this.slides[i1].pdfLinkInDam['@link'],
                  name: this.slides[i1].pdfLinkInDam['@name'],
                  path: this.slides[i1].pdfLinkInDam['@path'],
                };
              } else {
                this.slides[i1].pdfLinkInDam = null as any;
              }
            }
          }
        } else {
          this.slides = null as any;
        }
      }
    }
    return new OneCTTextInstance(props);
  }
}
